import { type PartnersBlock } from "@next-platform/packages-ts-types";

/**
 * Reads SpicyChat's pre-existing web-only affiliate identifiers from
 * `window.localStorage`:
 *
 * - `aff_id` — written raw by `persistAffiliateFromUrl` at boot when the
 *   landing URL carries `?aff_id=` or `?ref=`.
 * - `tap_vid` — written raw by Tapfiliate's injected script.
 *
 * Both keys are web-only by construction — native (React Native) never
 * wrote them. This module therefore lives in the web frontend, not in
 * the cross-platform `spicychat-business-logic` shim.
 *
 * Returns `undefined` when neither key is present, so the caller does
 * not end up calling the pure merge reducer with an empty patch.
 */
const LEGACY_AFF_ID_KEY = "aff_id";
const LEGACY_TAP_VID_KEY = "tap_vid";

export function readLegacyPartnerIds(): PartnersBlock | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }

  const affiliateId = window.localStorage.getItem(LEGACY_AFF_ID_KEY);
  const tapVid = window.localStorage.getItem(LEGACY_TAP_VID_KEY);

  const patch: PartnersBlock = {};
  let hasAny = false;

  // Falsy check (not `!== null && !== ""`) because `localStorage.getItem`
  // returns `null` for missing keys. Mirrors the falsy guard pattern used
  // by the envelope read path.
  if (affiliateId) {
    patch.affiliateId = affiliateId;
    hasAny = true;
  }
  if (tapVid) {
    patch.tapVid = tapVid;
    hasAny = true;
  }

  return hasAny ? patch : undefined;
}
